import React, { useEffect, useState } from "react";
import { CustomLoader } from "../../../../commonComponents/formComponents/loader";
import StatusDetailItemTitle from "./statusDetailItemTitle";
import { getAllCarmTransactions } from "../../../../apiCalls/jobInfo";
import StatusDetailItem from "./statusDetailItem";
import {Loader} from 'semantic-ui-react';
import './carmStatus.scss'

const CarmStatus = ({shipmentId}) => {
    const [carmTransactions, setCarmTransactions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [responseJson, setResponseJson] = useState({});
    const getCarmTransactions = async () => {
        setLoading(true);
        let response = await getAllCarmTransactions({
            shipmentId
        })
        if(response.data?.eventMessage){
            setCarmTransactions(response.data.eventMessage.carmTransactionResponses);
            setLoading(false);
        }
    }
    useEffect(() => {
        getCarmTransactions();
    }, [])
    return (
        <div className='topDiv carm-top-div'>
            {loading ? (
                <Loader>LOADING</Loader>
                ) : (carmTransactions && carmTransactions.length > 0) && (
                    carmTransactions.map((item, index) => (
                        <StatusDetailItem 
                            responseJson={responseJson} 
                            setResponseJson={setResponseJson} 
                            // enableRawXml={props.enableRawXml} 
                            item={item} 
                            index={index} 
                        />
                    ))
                )
            }
        </div>
     );
}
 


export default CarmStatus;